import { executeRequest } from './request';
import { DOMAIN_URL, MKS_SERVICE } from './configURL';

export function ping() {
	return new Promise((reject, resolve) => {
		executeRequest(DOMAIN_URL + MKS_SERVICE.PING, null, reject, resolve);
	});
}

export function getProjects() {
	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.GET_PROJECTS,
			null,
			reject,
			resolve
		);
	});
}

export function getProject(project_id) {
	const params = {
		project_id
	};

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.GET_PROJECT,
			params,
			reject,
			resolve
		);
	});
}

export function saveProject(params) {
	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.SAVE_PROJECT,
			params,
			reject,
			resolve
		);
	});
}

export function disableProject(project_id) {
	const params = {
		project_id
	};

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.DISABLE_PROJECT,
			params,
			reject,
			resolve
		);
	});
}

export function subscribe(params) {
	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.SUBSCRIBE,
			params,
			reject,
			resolve
		);
	});
}

// export function saveProject(name, city, is_protected, a2p, surface_treatment_code, project_type_id, date_of_receipt, project_id) {

// 	const params = {
// 		name,
// 		city,
// 		is_protected,
// 		a2p,
// 		surface_treatment_code,
// 		project_type_id,
// 		date_of_receipt
// 	}

// 	if(project_id) {
// 		params["project_id"] = project_id;
// 	}

// 	return new Promise((reject, resolve) => {
// 		executeRequest(
// 			DOMAIN_URL + MKS_SERVICE.SAVE_PROJECT,
// 			params,
// 			reject,
// 			resolve
// 		);
// 	});
// }

export function deleteProject(project_id) {
	const params = {
		project_id
	};

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.DELETE_PROJECT,
			params,
			reject,
			resolve
		);
	});
}

export function cloneProjectTemplate(project_id, project_template_code) {
	const params = {
		project_id,
		project_template_code
	};

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.CLONE_PROJECT_TEMPLATE,
			params,
			reject,
			resolve
		);
	});
}

export function getLockings(project_id) {
	const params = {
		project_id
	};

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.GET_LOCKINGS,
			params,
			reject,
			resolve
		);
	});
}

export function getCylindersTypes() {
	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.GET_CYLINDER_TYPES,
			null,
			reject,
			resolve
		);
	});
}

export function saveGroup(project_id, name, parent_locking_id) {
	const params = {
		project_id,
		name,
		is_locking: false,
		parent_locking_id
	};

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.SAVE_LOCKING,
			params,
			reject,
			resolve
		);
	});
}

// FIXME: rename with save
export function createLocking(
	project_id,
	fields,
	locking_id,
	is_locking,
	parent_locking_id
) {
	const params = {
		project_id,
		...fields,
		is_locking,
		parent_locking_id,

		// Options
		nb_servant_keys: 0,
		quantity: 1
	};

	if (locking_id) {
		params['locking_id'] = locking_id;
	}

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.SAVE_LOCKING,
			params,
			reject,
			resolve
		);
	});
}

export function updateLocking(project_id, locking_id, options) {}

// export function deleteLocking(project_id, locking_id) {

// }

export function saveLocking(options) {
	const params = {
		...options
	};

	if (typeof locking_id === 'number') {
		params['locking_id'] = locking_id;
	}

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.SAVE_LOCKING,
			params,
			reject,
			resolve
		);
	});
}

export function cloneLocking(project_id, locking_id, iteration) {
	const params = {
		project_id,
		locking_id,
		iteration
	};
	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.CLONE_LOCKING,
			params,
			reject,
			resolve
		);
	});
}

export function moveLocking(
	project_id,
	locking,
	parent_locking_id,
	after_locking_id
) {
	const params = {
		project_id,
		parent_locking_id,
		after_locking_id,
		...locking,
		nb_servant_keys: 0
	};
	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.SAVE_LOCKING,
			params,
			reject,
			resolve
		);
	});
}

export function deleteLocking(project_id, locking_id) {
	const params = {
		project_id,
		locking_id
	};

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.DELETE_LOCKING,
			params,
			reject,
			resolve
		);
	});
}

export function getRoles(project_id) {
	const params = {
		project_id
	};

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.GET_ROLES,
			params,
			reject,
			resolve
		);
	});
}

export function saveRole(project_id, name, number_of_keys, role_id) {
	const params = {
		project_id,
		name,
		number_of_keys
	};

	if (role_id) {
		params['role_id'] = role_id;
	}

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.SAVE_ROLE,
			params,
			reject,
			resolve
		);
	});
}

export function deleteRole(project_id, role_id) {
	const params = {
		project_id,
		role_id
	};

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.DELETE_ROLE,
			params,
			reject,
			resolve
		);
	});
}

export function changeRangeRoles(project_id, roles) {
	const params = {
		project_id,
		roles: JSON.stringify(roles)
	};

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.CHANGE_RANGE_ROLES,
			params,
			reject,
			resolve
		);
	});
}

export function addRights(project_id, roles, lockings) {
	const params = {
		project_id,
		roles: JSON.stringify(roles),
		lockings: JSON.stringify(lockings)
	};

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.ADD_RIGHTS,
			params,
			reject,
			resolve
		);
	});
}

export function deleteRights(project_id, roles, lockings) {
	const params = {
		project_id,
		roles: JSON.stringify(roles),
		lockings: JSON.stringify(lockings)
	};

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.DELETE_RIGHTS,
			params,
			reject,
			resolve
		);
	});
}

export function getOffer(project_id) {
	const params = {
		project_id
	};
	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.GET_OFFER,
			params,
			reject,
			resolve
		);
	});
}

export function getQuotation(project_id, product_line_id) {
	const params = {
		project_id,
		product_line_id
	};
	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.GET_QUOTATION,
			params,
			reject,
			resolve
		);
	});
}

export function contactUs(project_id, subject, message) {
	const params = {
		project_id,
		subject,
		message
	};
	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.CONTACT_US,
			params,
			reject,
			resolve
		);
	});
}

export function duplicatePattern(
	project_id,
	roles,
	lockings_to_duplicate,
	lockings_add_right,
	iteration
) {
	const params = {
		project_id,
		roles: JSON.stringify(roles),
		lockings_to_duplicate: JSON.stringify(lockings_to_duplicate),
		lockings_add_right: JSON.stringify(lockings_add_right),
		iteration
	};
	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + MKS_SERVICE.DUPLICATE_PATTERN,
			params,
			reject,
			resolve
		);
	});
}



// WEBPACK FOOTER //
// ./src/js/webAPI/MKSService.js